import { CONTRIBUTE_MODAL_NAME } from '@upright/ui/common/upright/model/input/contributions/contribution-modal';
import { openModal } from '@upright/ui/untidy/redux/modules/modal';

import { useDispatch } from 'react-redux';
import { BoxCta } from './common/box-cta';
import { RequestAccessOrContact } from '@upright/ui/untidy/text-elements';

export function EmptyStateGetAccessCTA() {
  const dispatch = useDispatch();
  const openContactModal = () => {
    dispatch(openModal(CONTRIBUTE_MODAL_NAME, { type: 'OPEN_COMMENT' }));
  };

  return (
    <BoxCta title={'Get full access'}>
      <RequestAccessOrContact
        openContactModal={() => {
          openContactModal();
        }}
      />
    </BoxCta>
  );
}
